import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Typography from '../../../../../../components/Typography';
import Button from '../../../../../../components/CustomButton';
import ViewAccountDeletion from './Deletion';

// Context
import { useDataSettingsContext } from '../../context';

// Styles
import styles from './style.module.scss';
import viewsStyles from '../views.module.scss';

const ViewAccountManage: React.FC = () => {
  const { t } = useTranslation();
  // Context
  const { onClose, onSetHeaderTitle } = useDataSettingsContext();

  // States
  const [isDeletionView, setIsDeletionView] = useState<boolean>(false);

  // Effects
  useEffect(() => {
    onSetHeaderTitle(t('profile.settings.data.account_management.title'));

    return () => {
      onSetHeaderTitle('');
    };
  }, [onSetHeaderTitle, t]);

  if (isDeletionView) {
    return <ViewAccountDeletion />;
  }

  return (
    <div className={viewsStyles.container}>
      <div className={viewsStyles.row}>
        <div className={viewsStyles.row_data}>
          <Typography variant="h3" className={viewsStyles.row_data_title}>
            {t('profile.settings.data.account_management.delete_account.title')}
          </Typography>

          <Typography variant="span" className={viewsStyles.row_data_description}>
            {t('profile.settings.data.account_management.delete_account.description')}
          </Typography>
        </div>

        <div className={viewsStyles.row_actions}>
          <Button
            variant='secondary'
            classes={{
              root: styles.deleteButton,
            }}
            onClick={() => setIsDeletionView(true)}
          >
            {t('actions.delete')}
          </Button>
        </div>
      </div>

      <div className={viewsStyles.actions}>
        <Button
          variant='primary'
          classes={{
            root: viewsStyles.actions_button,
          }}
          onClick={() => onClose()}
        >
          {t('actions.close')}
        </Button>
      </div>
    </div>
  );
}

export default ViewAccountManage;
